import Badge, { BadgeProps } from '@mui/material/Badge';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

const PREFIX = 'BadgeRow';

const classes = {
  badge: `${PREFIX}-badge`,
  badge2: `${PREFIX}-badge2`,
};

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  minWidth: 0,
  [`& .${classes.badge}`]: {
    marginLeft: theme.spacing(2.5),
    zIndex: 10,
    minWidth: 0,
    flex: '0 1 auto',
    '&:nth-of-type(1)': {
      marginLeft: 0,
    },
  },
  [`& .${classes.badge} .MuiChip-root`]: {
    maxWidth: '100%',
    minWidth: 0,
  },
  [`& .${classes.badge} .MuiChip-label`]: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

const LinearBadge = Badge;

type BadgeInfo = {
  text: string;
  total: number;
};

interface BadgeRowProps {
  badgeList: BadgeInfo[];
  size?: 'small' | 'medium';
  linear?: boolean;
}

const BadgeRow = ({ badgeList, size, linear = false }: BadgeRowProps) => (
  <Root>
    {
      badgeList.map((badge) => {
        const badgeProps: BadgeProps = {
          className: classes.badge,
          max: 9999999,
          badgeContent: badge.total,
          showZero: true,
          color: 'primary',
        };

        return (
          linear
            ? (
              <LinearBadge
                key={badge.text}
                {...badgeProps}
                classes={{
                  badge: classes.badge,
                }}
              >
                <Chip size={size} label={`${badge.text}`} />
              </LinearBadge>
            )
            : (
              <Badge key={badge.text} {...badgeProps}>
                <Chip size={size} label={`${badge.text}`} />
              </Badge>
            )
        );
      })
    }
  </Root>
);

export default BadgeRow;
